<template>
    <BaseSection v-if="blockEmbedUrl || blockEmbedCode">
        <BaseFigure :alt="alt || ''">
            <BaseEmbed
                :url="blockEmbedUrl"
                :code="blockEmbedCode"
                :height="blockEmbedHeight"
                :description="blockEmbedDescription"
            />
            <figcaption v-if="blockEmbedDescription">
                {{ blockEmbedDescription }}
            </figcaption>
        </BaseFigure>
    </BaseSection>
</template>

<script setup>
defineProps({
    blockEmbedUrl: {
        type: String,
        default: null,
        required: false,
    },
    blockEmbedCode: {
        type: String,
        default: null,
        required: false,
    },
    blockEmbedDescription: {
        type: String,
        default: null,
        required: false,
    },
    blockEmbedHeight: {
        type: Number,
        default: undefined,
        required: false,
    },
    alt: {
        type: String,
        default: '',
        required: false,
    },
});
</script>
